<template>
  <!-- 设备详情 -->
  <el-dialog
    title="设备信息修改"
    :visible.sync="deviceDialog"
    append-to-body
    width="800px"
    v-dialogDrag
    class="choose-box"
  >
    <!-- 主机 -->
    <el-form
      v-if="updateState == 2"
      ref="deviceForm"
      :rules="deviceRule"
      :model="deviceForm"
      label-width="130px"
      style="display: flex; justify-content: space-between; flex-flow: wrap"
    >
      <el-col :span="11">
        <el-form-item label="消防主机编号" prop="thirdDeviceId">
          <el-input v-model="deviceForm.thirdDeviceId" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="消防主机名称" prop="deviceName">
          <el-input v-model="deviceForm.deviceName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="设备厂商" prop="factoryId">
          <el-select
            v-model="deviceForm.factoryId"
            style="width: 100%"
            clearable
            placeholder="请选择厂商"
          >
            <el-option
              v-for="item in factoryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="消防型号" prop="deviceVersion">
          <el-select
            v-model="deviceForm.deviceVersion"
            style="width: 100%"
            clearable
            placeholder="请选择消防型号"
          >
            <el-option
              v-for="item in deviceVersionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="消防设备类型" prop="deviceMark">
          <el-select
            disabled
            v-model="deviceForm.deviceMark"
            style="width: 100%"
            placeholder="请选择消防型号"
          >
            <el-option
              v-for="item in deviceMarkList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!--      <el-col :span="11">-->
      <!--        <el-form-item label="IP地址"-->
      <!--                      prop="deviceHost">-->
      <!--          <el-input v-model="deviceForm.deviceHost"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <!--      <el-col :span="11">-->
      <!--        <el-form-item label="系统地址"-->
      <!--                      prop="mac">-->
      <!--          <el-input v-model="deviceForm.mac"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <!--      <el-col :span="11">-->
      <!--        <el-form-item label="类型标志"-->
      <!--                      prop="typeMark">-->
      <!--          <el-input v-model="deviceForm.typeMark"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <el-col :span="11">
        <el-form-item label="设备状态" prop="status">
          <el-select
            v-model="deviceForm.status"
            style="width: 100%"
            clearable
            disabled
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!--      <el-col :span="11">-->
      <!--        <el-form-item label="上传方式"-->
      <!--                      prop="codeType">-->
      <!--          <el-select v-model="deviceForm.codeType"-->
      <!--                     style="width: 100%"-->
      <!--                     placeholder="请选择上传方式">-->
      <!--            <el-option v-for="item in typeList"-->
      <!--                       :key="item.value"-->
      <!--                       :label="item.label"-->
      <!--                       :value="item.value">-->
      <!--            </el-option>-->
      <!--          </el-select>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <el-col :span="24">
        <el-form-item label="控制模式" prop="controlMode">
          <el-select
            v-model="deviceForm.controlMode"
            style="width: 100%"
            @change="controlModeChange"
            placeholder="请选择控制模式"
          >
            <el-option
              v-for="item in controlList"
              :key="'c' + item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <template v-if="isWaterLevel">
        <el-col :span="24" v-if="isWaterLevel">
          <el-form-item label="消防水位 (m)" prop="waterLevel">
            <el-input v-model="deviceForm.waterLevel" />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="低水位范围/m" prop="lowWaterThreshold">
            <el-input
              v-model="deviceForm.lowWaterThreshold"
              placeholder="范围格式:0-100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="低低水位范围/m" prop="llowWaterThreshold">
            <el-input
              v-model="deviceForm.llowWaterThreshold"
              placeholder="范围格式:0-100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="高水位范围/m" prop="highWaterThreshold">
            <el-input
              v-model="deviceForm.highWaterThreshold"
              placeholder="范围格式:0-100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="高高水位范围/m" prop="hhighWaterThreshold">
            <el-input
              v-model="deviceForm.hhighWaterThreshold"
              placeholder="范围格式:0-100"
            ></el-input>
          </el-form-item>
        </el-col>
      </template>

      <el-col :span="11" v-if="isShow">
        <el-form-item label="控制器编号" prop="controlCodeList">
          <el-select
            v-model="deviceForm.controlCodeList"
            style="width: 100%"
            multiple
            placeholder="请选择控制器编号"
          >
            <el-option
              v-for="item in controlCodeOption"
              :key="'d' + item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="备注说明" prop="thirdDeviceDesc">
          <el-input
            v-model="deviceForm.thirdDeviceDesc"
            type="textarea"
            placeholder="请输入备注说明"
            maxlength="255"
            show-word-limit
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <!-- 部件 -->
    <el-form
      v-else
      ref="deviceForms"
      :rules="deviceRules"
      :model="deviceForms"
      label-width="100px"
      style="display: flex; justify-content: space-between; flex-flow: wrap"
    >
      <el-col :span="11">
        <el-form-item label="部件名称" prop="deviceName">
          <el-input v-model="deviceForms.deviceName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="部件型号" prop="subDeviceMark">
          <el-select
            v-model="deviceForms.subDeviceMark"
            style="width: 100%"
            clearable
            placeholder="请选择部件型号"
          >
            <el-option
              v-for="item in subDeviceMarkList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="部件地址" prop="mac">
          <el-input v-model="deviceForms.mac"></el-input>
        </el-form-item>
      </el-col>
      <!--      <el-col :span="11">-->
      <!--        <el-form-item label="回路"-->
      <!--                      prop="loop">-->
      <!--          <el-input v-model="deviceForms.loop"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <!--      <el-col :span="11">-->
      <!--        <el-form-item label="二次码"-->
      <!--                      prop="secondaryCode">-->
      <!--          <el-input v-model="deviceForms.secondaryCode"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <!--      <el-col :span="11">-->
      <!--        <el-form-item label="控制器编号"-->
      <!--                      prop="controlCode">-->
      <!--          <el-input v-model="deviceForms.controlCode"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <el-col :span="24">
        <el-form-item label="部件说明" prop="thirdDeviceDesc">
          <el-input
            v-model="deviceForms.thirdDeviceDesc"
            type="textarea"
            placeholder="请输入部件说明"
            maxlength="255"
            show-word-limit
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="closeForm">取消</el-button>

      <el-button type="primary" @click="saveForm">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { api } from "../api";
import { Dic } from "$utils";

const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};
export default {
  components: {},
  props: {
    deviceId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pointId: "",
      deviceDialog: false,
      updateState: "",
      isShow: false,
      isWaterLevel: false,
      controlCodeOption: Dic.find("SENU095001"),
      deviceVersionList: Dic.find("SENU095"),
      subDeviceMarkList: Dic.find("SENU094"),
      factoryList: [],
      deviceMarkList: [],
      controlList: [
        { label: "单机模式", value: "0" },
        { label: "多分机模式", value: "1" },
      ],
      statusList: [
        { label: "在线", value: 1 },
        { label: "离线", value: 0 },
      ],
      typeList: [
        { label: "回路部件", value: "0" },
        { label: "用户编码", value: "1" },
      ],
      deviceForm: {
        thirdDeviceDesc: "", //
        controlMode: "", //
        codeType: "", //
        status: "", //
        typeMark: "", //
        // deviceHost: "", //
        deviceVersion: "", //
        deviceName: "", //
        factoryId: "", //
        waterLevel: "", //
        lowWaterThreshold: "",
        llowWaterThreshold: "",
        highWaterThreshold: "",
        hhighWaterThreshold: "",
        thirdDeviceId: "", //
        controlCodeList: [],
      },
      deviceForms: {
        thirdDeviceDesc: "",
        subDeviceMark: "", //
        mac: "", //
        // loop: "", //
        secondaryCode: "", //
        deviceName: "", //
        // controlCode: "", //
        deviceId: "", //
      },
      deviceRule: {
        codeType: [{ required: true, message: "请输入", trigger: "change" }],
        status: [{ required: true, message: "请输入", trigger: "change" }],
        controlCodeList: [{ required: true, message: "请输入", trigger: "change" }],
        typeMark: [{ required: true, message: "请输入", trigger: "change" }],
        controlMode: [{ required: true, message: "请输入", trigger: "change" }],
        factoryId: [{ required: true, message: "请输入", trigger: "change" }],
        deviceVersion: [{ required: true, message: "请输入", trigger: "change" }],
        deviceName: [{ required: true, message: "请输入", trigger: "blur" }],
        waterLevel: [{ required: true, message: "请输入", trigger: "blur" }],
        // deviceHost: [{ required: true, message: "请输入", trigger: "blur" }],
        lowWaterThreshold: [{ required: true, message: "请输入", trigger: "blur" }],
        llowWaterThreshold: [{ required: true, message: "请输入", trigger: "blur" }],
        highWaterThreshold: [{ required: true, message: "请输入", trigger: "blur" }],
        hhighWaterThreshold: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      deviceRules: {
        subDeviceMark: [{ required: true, message: "请输入", trigger: "change" }],
        deviceName: [{ required: true, message: "请输入", trigger: "change" }],
        mac: [{ required: true, message: "请输入", trigger: "blur" }],
        // loop: [{ required: true, message: "请输入", trigger: "blur" }],
        thirdDeviceDesc: [{ required: true, message: "请输入", trigger: "change" }],
      },
    };
  },
  mounted() {
    Dic.find("SENU087").map((item) => {
      if (
        item.value == "27" ||
        item.value == "28" ||
        item.value == "29" ||
        item.value == "35" ||
        item.value == "36" ||
        item.value == "37"
      ) {
        this.deviceMarkList.push(item);
      }
    });
    this.queryFactoryList();
  },
  methods: {
    // 获取厂商下拉列表
    queryFactoryList() {
      this.$fetch(api.device.queryFactoryList).then((res) => {
        if (res.success) {
          this.factoryList = res.returnObj.map((item) => {
            return {
              label: item.factoryName,
              value: Number(item.factoryId),
            };
          });
        }
      });
    },
    open(item, id) {
      console.log("---弹框信息值---", item);
      this.pointId = id;
      this.deviceDialog = true;
      if (item.subDeviceMark) {
        // 部件
        this.updateState = "1";
        this.deviceForm = {};
        this.deviceForms = {
          subDeviceMark: Number(item.subDeviceMark), //
          mac: item.mac, //
          loop: item.loop, //
          secondaryCode: item.secondaryCode, //
          deviceName: item.deviceName, //
          factoryId: item.factoryId, //
          controlCode: item.controlCode, //
          deviceId: item.deviceId, //
          thirdDeviceDesc: item.thirdDeviceDesc, //
        };
      } else {
        // 主机
        // this.isShow =
        //   item.controlMode === "1" && (item.deviceMark == 28 || item.deviceMark == 29);
        this.isWaterLevel = item.deviceType == 36 || item.deviceType == 37;
        this.updateState = "2";
        this.deviceForms = {};
        this.deviceForm = {
          thirdDeviceDesc: item.thirdDeviceDesc, //
          controlMode: item.controlMode, //
          // codeType: item.codeType, //
          deviceVersion: Number(item.deviceVersion),
          // mac: item.mac, //
          status: item.status, //
          typeMark: item.typeMark, //
          deviceHost: item.ip, //
          deviceMark: Number(item.deviceType), //
          factoryId: item.factoryId, //
          factoryName: item.factoryName, //
          deviceName: item.deviceName, //
          thirdDeviceId: item.thirdDeviceId, //
          deviceId: item.deviceId, //
          waterLevel: item.waterLevel, //
          controlCodeList: [],
          lowWaterThreshold: item.lowWaterThreshold, //
          llowWaterThreshold: item.llowWaterThreshold, //
          highWaterThreshold: item.highWaterThreshold, //
          hhighWaterThreshold: item.hhighWaterThreshold, //
        };
        if (item.controlCode) {
          let arr = item.controlCode.split(",");
          arr.forEach((items) => {
            this.deviceForm.controlCodeList.push(Number(items));
          });
        }
      }
    },
    controlModeChange(data) {
      this.isShow =
        (this.deviceForm.deviceMark == 28 || this.deviceForm.deviceMark == 29) &&
        data == "1";
    },
    // 修改设备信息确认
    saveForm() {
      if (this.updateState == 1) {
        // 部件
        this.$refs["deviceForms"].validate((valid) => {
          if (valid) {
            let form = {
              deviceID: this.deviceForms.deviceId,
              factoryId: this.deviceForms.factoryId,
              subDeviceMark: this.deviceForms.subDeviceMark,
              mac: this.deviceForms.mac,
              loop: this.deviceForms.loop,
              thirdDeviceName: this.deviceForms.deviceName,
              thirdDeviceDesc: this.deviceForms.thirdDeviceDesc,
              secondaryCode: this.deviceForms.secondaryCode,
              controlCode: this.deviceForms.controlCode,
            };
            this.$fetch(api.cms.updateFireSubDevice, form).then((res) => {
              if (res && res.success) {
                this.deviceDialog = false;
                this.$message.success("修改成功");
                this.$emit("refreshPop");
              } else {
                this.$message.error(res.msgContent || "设备数据修改失败");
              }
            });
          }
        });
      } else {
        // 主机
        this.$refs["deviceForm"].validate((valid) => {
          if (valid) {
            let params = {
              controlMode: this.deviceForm.controlMode, //
              deviceMark: this.deviceForm.deviceMark,
              // codeType: this.deviceForm.codeType,
              // mac: this.deviceForm.mac, //
              status: this.deviceForm.status, //
              typeMark: this.deviceForm.typeMark, //
              deviceVersion: this.deviceForm.deviceVersion, //
              deviceHost: this.deviceForm.deviceHost, //
              thirdDeviceId: this.deviceForm.thirdDeviceId, //
              deviceID: this.deviceForm.deviceId,
              factoryId: this.deviceForm.factoryId,
              thirdDeviceName: this.deviceForm.deviceName,
              waterLevel: this.deviceForm.waterLevel,
              thirdDeviceDesc: this.deviceForm.thirdDeviceDesc, //
              lowWaterThreshold: this.deviceForm.lowWaterThreshold, //
              llowWaterThreshold: this.deviceForm.llowWaterThreshold, //
              highWaterThreshold: this.deviceForm.highWaterThreshold, //
              hhighWaterThreshold: this.deviceForm.hhighWaterThreshold, //
            };
            if (
              this.deviceForm.controlMode == "1" &&
              (this.deviceForm.deviceMark == 29 || this.deviceForm.deviceMark == 28)
            ) {
              params.controlCodeList = this.deviceForm.controlCodeList;
            }
            this.$fetch(api.cms.updateFireDevice, params).then((res) => {
              if (res.success) {
                this.deviceDialog = false;
                this.$message.success("修改成功");
                this.$emit("refreshPop");
              } else {
                this.$message.error(res.msgContent || "设备数据修改失败");
              }
            });
          }
        });
      }
    },
    closeForm() {
      this.deviceDialog = false;
      this.$refs.deviceForm && this.$refs.deviceForm.resetFields();
      this.$refs.deviceForms && this.$refs.deviceForms.resetFields();
      this.deviceForm = {};
      this.deviceForms = {};
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
</style>
